export type NavChild = { label: string; href: string; description: string };
export type NavItem = { label: string; href: string; children?: NavChild[] };

export const navItems: NavItem[] = [
  {
    label: "Nos spécialités",
    href: "/specialites",
    children: [
      { label: "Chauffage", href: "/specialites/chauffage", description: "Chauffage stationnaire air et eau" },
      { label: "Isolation", href: "/specialites/isolation", description: "Confort thermique et acoustique" },
      { label: "Électricité", href: "/specialites/electricite", description: "Batteries, 230 V et panneaux solaires" },
      { label: "Gaz & Eau", href: "/specialites/gaz-eau", description: "Circuits gaz et eau aux normes" },
      { label: "Pose de fenêtre", href: "/specialites/fenetres", description: "Baies, lanterneaux et aérations" },
      { label: "Accessoires", href: "/specialites/accessoires", description: "Stores, porte-vélos, rangements" },
    ],
  },
  {
    label: "Nos aménagements",
    href: "/amenagements",
    children: [
      { label: "Aménagement complet", href: "/amenagements/complet", description: "Votre van clé en main, sur mesure" },
      { label: "Banquette-lit", href: "/amenagements/banquette-lit", description: "Banquettes homologuées convertibles" },
      { label: "Toit relevable", href: "/amenagements/toit-relevable", description: "Un couchage en plus, en un geste" },
      { label: "Mobilier & cuisine", href: "/amenagements/mobilier", description: "Meubles bois et cuisine fonctionnelle" },
    ],
  },
  { label: "Homologation", href: "/homologation" },
  { label: "Véhicules", href: "/vehicules" },
  { label: "Notre équipe", href: "/equipe" },
  { label: "Contact", href: "/contact" },
  { label: "Blog", href: "/blog" },
  { label: "FAQ", href: "/faq" },
];
